<template>
    <ValidationErrors :show="showErrors"/>
    <Head :title="'Quotes - ' + fixture.title"/>
    <div class="w-full mb-6">
        <FixtureHeader :fixture="fixture"></FixtureHeader>
        <div class="space-y-6 lg:col-span-9">
            <section aria-labelledby="payment-details-heading">
                <form @submit.prevent="submit">
                    <div class="shadow sm:rounded-md sm:overflow-hidden">
                        <div class="bg-white px-4 p-6 space-y-6">
                            <div class="flex pb-5 border-b border-gray-200 justify-between items-center">
                                <h3 class="text-lg leading-6 font-bold text-gray-900">Quotes</h3>
                                <div class="flex items-center">
                                    <strong class="text-sm">Filter by:</strong>
                                    <PopoverGroup class="hidden sm:flex sm:items-baseline sm:space-x-8">
                                        <Popover as="div" id="desktop-menu"
                                                 class="ml-3 relative z-0 inline-block text-left">
                                            <div>
                                                <Link
                                                    :href="route('frontend.fixture.quote.index', [fixture.id])"
                                                    class="group inline-flex items-center justify-center text-sm font-medium text-gray-700 hover:text-gray-900">
                                                    <span class="underline">All Quotes</span>
                                                    <span
                                                        class="ml-1.5 rounded py-0.5 px-1.5 bg-blue-200 text-xs font-semibold text-gray-700 tabular-nums">{{
                                                            quote_count.all
                                                        }}</span>
                                                </Link>
                                            </div>
                                        </Popover>
                                        <Popover as="div" id="desktop-menu"
                                                 class="relative z-0 inline-block text-left">
                                            <div>
                                                <Link
                                                    :href="route('frontend.fixture.quote.status', [fixture.id, 'not-sent'])"
                                                    class="group inline-flex items-center justify-center text-sm font-medium text-gray-700 hover:text-gray-900">
                                                    <span class="underline">Not Sent Quotes</span>
                                                    <span
                                                        class="ml-1.5 rounded py-0.5 px-1.5 bg-gray-200 text-xs font-semibold text-gray-700 tabular-nums">{{
                                                            quote_count.not_sent
                                                        }}</span>
                                                </Link>
                                            </div>
                                        </Popover>
                                        <Popover as="div" id="desktop-menu"
                                                 class="relative z-0 inline-block text-left">
                                            <div>
                                                <Link
                                                    :href="route('frontend.fixture.quote.status', [fixture.id, 'sent'])"
                                                    class="group inline-flex items-center justify-center text-sm font-medium text-gray-700 hover:text-gray-900">
                                                    <span class="underline">Sent Quotes</span>
                                                    <span
                                                        class="ml-1.5 rounded py-0.5 px-1.5 bg-yellow-200 text-xs font-semibold text-gray-700 tabular-nums">{{
                                                            quote_count.sent
                                                        }}</span>
                                                </Link>
                                            </div>
                                        </Popover>
                                        <Popover as="div" id="desktop-menu"
                                                 class="relative z-0 inline-block text-left">
                                            <div>
                                                <Link
                                                    :href="route('frontend.fixture.quote.status', [fixture.id, 'confirmed'])"
                                                    class="group inline-flex items-center justify-center text-sm font-medium text-gray-700 hover:text-gray-900">
                                                    <span class="underline">Confirmed Quotes</span>
                                                    <span
                                                        class="ml-1.5 rounded py-0.5 px-1.5 bg-green-200 text-xs font-semibold text-gray-700 tabular-nums">{{
                                                            quote_count.confirmed
                                                        }}</span>
                                                </Link>
                                            </div>
                                        </Popover>
                                    </PopoverGroup>
                                </div>
                                <div class="flex text-right items-end">
                                    <Button @click="create"
                                            class="shadow-md inline-flex items-center px-3 py-2 border border-transparent shadow-sm text-sm leading-4 rounded-md text-white bg-pitch-purple focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                        <svg class="-ml-0.5 mr-2 h-4 w-4" xmlns="http://www.w3.org/2000/svg"
                                             fill="none"
                                             viewBox="0 0 24 24"
                                             stroke="currentColor" aria-hidden="true">
                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                  stroke-width="2"
                                                  d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                                        </svg>
                                        Create New Quote
                                    </Button>

                                </div>
                            </div>
                            <div v-if="cant_confirm_quotes" class="rounded-md bg-red-100 p-4">
                                <div class="flex">
                                    <div class="flex-shrink-0">
                                        <InformationCircleIcon class="h-5 w-5 text-red-400" aria-hidden="true"/>
                                    </div>
                                    <div class="ml-3 space-y-3">
                                        <p class="text-sm text-black-700">Some of your quotes have clients without CMIDs or Suppliers without SMIDs.
                                            <a class="text-gray-700 hover:text-gray-900 underline cursor-pointer" @click="show_cmid_smid_errors = !show_cmid_smid_errors">Click here to view issues</a></p>
                                        <ul v-if="show_cmid_smid_errors && quotes.length > 0" class="list-disc ml-5">
                                            <li v-for="(cmid_smid_error, index) in cmid_smid_errors" :key="index" class="text-sm text-black-700">
                                                <a :href="route('frontend.organisations.' + cmid_smid_error.type + '.organisation.show', [cmid_smid_error.id])"
                                                    class="underline cursor-pointer" target="_blank">
                                                    {{ cmid_smid_error.name }}
                                                </a>
                                            </li>
                                        </ul>
                                            <p class="text-sm text-black-700">Please email finance at <a href="mailto:sports.receipts@destinationsport.com" class="cursor-pointer underline">sports.receipts@destinationsport.com</a> to check client CMIDs and
                                                <a href="mailto:sports.payments@destinationsport.com" class="cursor-pointer underline">sports.payments@destinationsport.com</a> to check supplier SMIDs that are in Unit 4.</p>
                                    </div>
                                </div>
                            </div>

                            <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                                <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                                    <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                                        <table class="min-w-full divide-y divide-gray-200">
                                            <thead class="bg-gray-50">
                                            <tr>
                                                <th scope="col"
                                                    class="px-3 py-4 text-left text-xs text-gray-500 uppercase tracking-wider border-r">
                                                </th>
                                                <th scope="col"
                                                    class="px-3 py-4 text-left text-xs text-gray-500 uppercase tracking-wider border-r">
                                                    Quote
                                                </th>
                                                <th scope="col"
                                                    class="px-3 py-4 text-left text-xs text-gray-500 uppercase tracking-wider border-r">
                                                    Client
                                                </th>
                                                <th scope="col"
                                                    class="px-3 py-4 text-left text-xs text-gray-500 uppercase tracking-wider border-r">
                                                    Status
                                                </th>
                                                <th scope="col"
                                                    class="px-3 py-4 text-left text-xs text-gray-500 uppercase tracking-wider border-r">
                                                    Net Sell
                                                </th>
                                                <th scope="col"
                                                    class="px-3 py-4 text-left text-xs text-gray-500 uppercase tracking-wider border-r">
                                                    Gross Sell
                                                </th>
                                                <th scope="col"
                                                    class="px-3 py-4 text-left text-xs text-gray-500 uppercase tracking-wider border-r">
                                                    Net Buy
                                                </th>
                                                <th scope="col"
                                                    class="px-3 py-4 text-left text-xs text-gray-500 uppercase tracking-wider border-r">
                                                    Gross Buy
                                                </th>
                                                <th scope="col"
                                                    class="px-3 py-4 text-left text-xs text-gray-500 uppercase tracking-wider border-r">
                                                    Management Fees
                                                </th>
                                                <th scope="col"
                                                    class="px-3 py-4 text-left text-xs text-gray-500 uppercase tracking-wider border-r">
                                                    Commission
                                                </th>
                                                <th scope="col"
                                                    class="px-3 py-4 text-left text-xs text-gray-500 uppercase tracking-wider border-r">
                                                    Net Profit
                                                </th>
                                                <th scope="col"
                                                    class="px-3 py-4 text-left text-xs text-gray-500 uppercase tracking-wider border-r">
                                                    Gross Profit
                                                </th>
                                                <th scope="col"
                                                    class="px-3 py-4 text-left text-xs text-gray-500 uppercase tracking-wider">
                                                    Profit %
                                                </th>
                                                <th scope="col"
                                                    class="px-3 py-4 text-left text-xs text-gray-500 uppercase tracking-wider">
                                                </th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr v-if="quotes.length > 0" v-for="(quote, index) in quotes" :key="index"
                                                :class="{'bg-gray-100': quote.status === 'Not Sent', 'bg-yellow-100' : quote.status === 'Sent to Client', 'bg-green-100' : quote.status === 'Confirmed'}"
                                                class="hover:bg-gray-50 cursor-pointer border">
                                                <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-900 text-left border-r">
                                                    <button v-if="!quote.check_can_confirm.length" type="button"
                                                            @click="confirmQuote(quote.id)" title="Confirm Quote"
                                                            class="shadow-md inline-flex mr-3 items-center px-[0.375rem] py-1 border border-transparent shadow-sm text-xs leading-4 font-medium rounded-md text-white bg-green-500 hover:bg-green-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500">
                                                        <CheckCircleIcon class="h-4 w-4"
                                                                         aria-hidden="true"/>
                                                    </button>
                                                    <button v-if="quote.check_can_confirm.length" :title="quote.check_can_confirm"
                                                        class="shadow-md inline-flex mr-3 items-center px-[0.375rem] py-1 border border-transparent shadow-sm text-xs leading-4 font-medium rounded-md text-white bg-red-500 hover:bg-red-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500">
                                                        <ExclamationCircleIcon class="h-4 w-4" aria-hidden="true" />
                                                    </button>
                                                    <button @click="edit(quote)"
                                                         title="Edit Quote"
                                                        class="shadow-md inline-flex items-center px-[0.375rem] py-1 border border-transparent shadow-sm text-xs leading-4 font-medium rounded-md text-white bg-gray-600 hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500">
                                                        <PencilIcon class="h-4 w-4" aria-hidden="true"/>
                                                    </button>
                                                </td>
                                                <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-900 border-r ">
                                                    <Link :href="route('frontend.fixture.quote.show', [fixture.id, quote.id])" class="underline">{{ quote.name }}</Link>
                                                </td>
                                                <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-900 border-r">
                                                    <Link
                                                        :href="route('frontend.organisations.clients.organisation.show', quote.client.id)"
                                                        class="underline">{{ quote.client.name }}
                                                    </Link>
                                                </td>
                                                <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-900 border-r">
                                                    <span v-if="quote.status === 'Not Sent'"
                                                          class="inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-medium shadow-md bg-gray-500 text-white"> {{
                                                            quote.status
                                                        }} </span>
                                                    <span v-if="quote.status === 'Sent to Client'"
                                                          class="inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-medium shadow-md bg-gray-100 text-yellow-800"> {{
                                                            quote.status
                                                        }} </span>
                                                    <span v-if="quote.status === 'Confirmed'"
                                                          class="inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-medium shadow-md bg-gray-100 text-green-800"> {{
                                                            quote.status
                                                        }} </span>
                                                    <span v-if="quote.status === 'On Hold'"
                                                          class="inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-medium shadow-md bg-gray-100 text-orange-500"> {{
                                                            quote.status
                                                        }} </span>
                                                    <span v-if="quote.status === 'Declined'"
                                                          class="inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-medium shadow-md bg-gray-100 text-red-500"> {{
                                                            quote.status
                                                        }} </span>
                                                    <span v-if="quote.status === 'Suppressed'"
                                                          class="inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-medium shadow-md bg-gray-100 text-gray-500"> {{
                                                            quote.status
                                                        }} </span>
                                                </td>
                                                <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-900 border-r">
                                                    {{  formatCurrency(quote.subtotals.net_sell_total, quote.sell_currency.code ?? 'GBP' , true) }}
                                                </td>
                                                <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-900 border-r">
                                                    {{  formatCurrency(quote.subtotals.gross_sell_total, quote.sell_currency.code ?? 'GBP' , true) }}
                                                </td>
                                                <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-900 border-r">
                                                    {{
                                                        formatCurrency(quote.subtotals.net_buy_total, quote.buy_currency.code ?? 'GBP' , true)
                                                    }}
                                                </td>
                                                <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-900 border-r">
                                                    {{
                                                        formatCurrency(quote.subtotals.gross_buy_total, quote.buy_currency.code ?? 'GBP' , true)
                                                    }}
                                                </td>
                                                <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-900 border-r">
                                                    {{
                                                        formatCurrency(quote.subtotals.management_fees_gross ?? quote.subtotals.management_fees, quote.sell_currency.code ?? 'GBP' , true)
                                                    }}
                                                </td><td class="px-3 py-4 whitespace-nowrap text-sm text-gray-900 border-r">
                                                    {{
                                                    formatCurrency(quote.subtotals.commission, quote.buy_currency.code ?? 'GBP' , true)

                                                }}
                                                </td>
                                                <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-900 border-r">
                                                    {{
                                                        formatCurrency(quote.subtotals.net_profit_total, quote.sell_currency.code ?? 'GBP', true)
                                                    }}
                                                </td>
                                                <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-900 border-r">
                                                    {{
                                                        formatCurrency(quote.subtotals.gross_profit_total, quote.sell_currency.code ?? 'GBP', true)
                                                    }}
                                                </td>
                                                <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-900 border-r">
                                                    {{
                                                        number_format(parseFloat(quote.subtotals.profit_percentage).toFixed(2))
                                                    }}%
                                                </td>
                                                <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-900">
                                                    <button type="button" @click="duplicateQuote(quote.id)" title="Duplicate Quote"
                                                            class="shadow-md inline-flex mr-3 items-center px-[0.375rem] py-1 border border-transparent shadow-sm text-xs leading-4 font-medium rounded-md text-black bg-gray-200 hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-200">
                                                        <ClipboardCopyIcon class="h-4 w-4"
                                                                           aria-hidden="true"/>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr v-else>
                                                <td colspan="10"
                                                    class="px-3 py-4 whitespace-nowrap text-sm text-gray-900">
                                                    There are no quotes available.
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div v-if="quotes.length > 0" class="flex gap-3 text-xs mt-6">
                                        <span class="font-bold">Quote Options:</span>
                                        <a :href="route('frontend.fixture.internal_export_fixture_quotes', [fixture.id])" class="flex hover:underline cursor-pointer">
                                            <DocumentDownloadIcon class="w-4 h-4 mr-2 text-light-pitch-purple"/>Export All Quotes - Internal
                                        </a>
                                        <a :href="route('frontend.fixture.export_fixture_quotes', [fixture.id])" class="flex hover:underline cursor-pointer">
                                            <DocumentDownloadIcon class="w-4 h-4 mr-2 text-green-500"/>Export All Quotes - Client Version
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </section>
        </div>
    </div>
    <CreateQuote ref="slideout"/>
    <DuplicateQuote ref="duplicate_quote"/>
</template>


<script>
import Authenticated from "@/Layouts/Authenticated";
import {Link, Head} from "@inertiajs/vue3";
import {
    ClipboardCopyIcon,
    PlusSmIcon,
    UsersIcon,
    InformationCircleIcon,
    ChevronDownIcon,
    CogIcon,
    PencilIcon,
    CheckCircleIcon,
    DocumentDownloadIcon,
    ExclamationCircleIcon
} from "@heroicons/vue/outline"
import ValidationErrors from "@/Components/ValidationErrors";
import FixtureHeader from "@/Components/FixtureHeader";
import CreateQuote from "@/Components/SlideOuts/CreateQuote";
import {Popover, PopoverButton, PopoverGroup} from "@headlessui/vue";
import Button from "@/Components/Button";
import { router } from '@inertiajs/vue3'
import DuplicateQuote from "@/Components/SlideOuts/DuplicateQuote";

export default {
    layout: Authenticated,
    components: {
        DuplicateQuote,
        Button,
        CreateQuote,
        FixtureHeader,
        ValidationErrors,
        Link,
        Head,
        PlusSmIcon,
        UsersIcon,
        InformationCircleIcon,
        Popover,
        PopoverButton,
        ChevronDownIcon,
        PopoverGroup,
        CogIcon,
        PencilIcon,
        ClipboardCopyIcon,
        CheckCircleIcon,
        DocumentDownloadIcon,
        ExclamationCircleIcon
    },
    props: {
        fixture: Object,
        quotes: Object,
        quote_count: Object,
        service_lines: Object,
        cant_confirm_quotes: Boolean,
        cmid_smid_errors: Array,
        show_cmid_smid_errors: Boolean,
        clients: Object
    },
    setup() {
        let show_cmid_smid_errors = false;
    },
    data() {
        return {
            showErrors: false,
        }
    },
    methods: {
        create() {
            this.$refs.slideout.updating = false;
            this.$refs.slideout.client_id = this.fixture.client.id;
            this.$refs.slideout.trading_details = this.trading_details;
            this.$refs.slideout.open();
        },
        edit(quote) {
            this.$refs.slideout.updating = true;
            this.$refs.slideout.form.id = quote.id;
            this.$refs.slideout.form.decline_reason = quote.decline_reason;
            this.$refs.slideout.form.name = quote.name;
            this.$refs.slideout.form.client = quote.client.name;
            this.$refs.slideout.form.client_id = quote.client_id;
            this.$refs.slideout.form.status = quote.status;
            this.$refs.slideout.form.fixture_id = quote.fixture_id;
            this.$refs.slideout.form.exchange_rate = quote.exchange_rate;
            this.$refs.slideout.form.buy_currency_id = quote.buy_currency_id ?? ""
            this.$refs.slideout.form.sell_currency_id = quote.sell_currency_id ?? ""
            this.$refs.slideout.open();
        },
        confirmQuote(id) {
            this.$swal.fire({
                title: 'Confirm Quote',
                text: "You are confirming a quote. Are you sure you'd like to do this?",
                showCloseButton: true,
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                stopKeydownPropagation: true,
                keydownListenerCapture: true
            })
                .then((result) => {
                    if (result.isConfirmed) {
                        this.$inertia.post(route('frontend.fixture.quote.confirm', [this.fixture.id, id]), {
                            preserveScroll: true,
                            onError: (page) => {
                                this.loading = false
                                this.showErrors = true
                            }
                        });
                    }
                });
        },
        duplicateQuote(id) {
            this.$refs.duplicate_quote.form.quote_id = id;
            this.$refs.duplicate_quote.open();
        },
        number_format(nStr) {
            nStr += '';
            let x = nStr.split('.');
            let x1 = x[0];
            let x2 = x.length > 1 ? '.' + x[1] : '';
            let rgx = /(\d+)(\d{3})/;
            while (rgx.test(x1)) {
                x1 = x1.replace(rgx, '$1' + ',' + '$2');
            }
            return x1 + x2;
        },
        doRounding(value, decimals) {
            return Number(Math.round(value + "e" + decimals) + "e-" + decimals).toFixed(2);
        },
    }
}
</script>
